<template>
  <el-row type="flex" class="w-full">
    <el-col>
      <el-row v-if="!audioFile" type="flex" justify="center" class="w-full">
        <el-button
          class="w-full"
          :type="recording ? 'danger' : 'success'"
          @click="toggleRecord"
          round
        >
          {{ recording ? `${recordingTime} - Press to review` : "Press to talk" }}
        </el-button>
      </el-row>
      <el-row v-else type="flex" justify="center" class="w-full">
        <audio class="h-[30px]" controls :src="audioURL"></audio>
      </el-row>
    </el-col>
  </el-row>
</template>

<script>
export default {
  props: ["audioFile"],
  data() {
    return {
      mediaRecorder: null,
      chunks: [],
      recording: false,
      audioURL: null,
      startTime: null,
      recordingTime: "00:00",
      interval: null,
    };
  },
  methods: {
    toggleRecord() {
      if (!this.recording) {
        this.startRecording();
      } else {
        this.stopRecording();
      }
    },
    startRecording() {
      this.startTime = new Date();
      this.updateRecordingTime();
      navigator.mediaDevices
        .getUserMedia({ audio: true })
        .then((stream) => {
          this.mediaRecorder = new MediaRecorder(stream);
          this.mediaRecorder.ondataavailable = (e) => {
            if (e.data && e.data.size > 0) {
              this.chunks.push(e.data);
            }
          };
          this.mediaRecorder.start();
          this.recording = true;
        })
        .catch((err) => {
          console.error("Error accessing microphone:", err);
          this.$notify.error({
            title: "Error",
            position: "bottom-right",
            message: "Error accessing microphone",
          });
        });
    },
    stopRecording() {
      if (!this.mediaRecorder) {
        return;
      }
      this.mediaRecorder.stop();
      this.recording = false;

      // Wait for all data to be available before creating the Blob
      const waitForData = new Promise((resolve) => {
        this.mediaRecorder.onstop = resolve;
      });

      waitForData.then(() => {
        const audioFile = new Blob(this.chunks, { type: "audio/wav" });
        this.$emit("updateAudioFile", audioFile);
        this.audioURL = URL.createObjectURL(audioFile);

        // Close the media stream to release the microphone
        this.mediaRecorder.stream.getTracks().forEach((track) => track.stop());

        // Clear interval
        clearInterval(this.interval);
      });
    },
    toggleRecording() {
      if (!this.recording) {
        this.startRecording();
      } else {
        this.stopRecording();
      }
    },
    updateRecordingTime() {
      this.interval = setInterval(() => {
        const currentTime = new Date();
        const elapsedTime = new Date(currentTime - this.startTime);
        if (elapsedTime > 0) {
          this.recordingTime = elapsedTime.toISOString().substr(14, 5);
          // Stop recording after 30 seconds
          if (elapsedTime >= 30000) {
            // 30 seconds in milliseconds
            clearInterval(this.interval);
            this.stopRecording();
          }
        }
      }, 1000);
    },
    cancelAudio() {
      this.mediaRecorder = null;
      this.chunks = [];
      this.$emit("updateAudioFile", null);
      this.recording = false;
      this.audioURL = null;
      this.startTime = null;
      this.recordingTime = "00:00";
      this.interval = null;
    },
  },
};
</script>
